import React from 'react';
import MasterComponentWraper from '../../components/Backend/MasterComponentWraper';

const NotFoundScreen = () => {
    return (
        <div class=" text-center error_page" style={{paddingTop: '30px'}}>
            <div class="rs_alert alert fade show alert-danger" role="alert">
                <div>No page found</div>
            </div>
        </div>
    )
}

export default (MasterComponentWraper(NotFoundScreen));